<template>
  <div>
    <LeftSidebar
      :visible="visible"
      baseClass="parvandeh-roles-wrapper"
      :title="generateTitle"
      :width="700"
      :hasBack="toggleHistory"
      :hasFooter="!toggleHistory"
      @back="backToRoles"
      @close="close"
    >
      <template>
        <div v-if="visible">
          <ParvandehRoleHistory
            v-if="toggleHistory"
            :parvandehCode="parvandehData.code"
          />
          <ParvandehRoleSelect
            v-else
            :parvandehCode="parvandehData.code"
            @getSelectedRoles="handleSelectedRoles"
          />
        </div>
      </template>
      <template #footer>
        <Button
          variant="outline-primary"
          :text="$lang.history"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          @click="showHistory"
        />
        <Button
          variant="primary"
          :text="$lang.edit"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          :loading="loading"
          @click="submit"
        />
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import LeftSidebar from "@/components/re-design/sidebar/LeftSidebar.vue";
import { Button } from "@/components/re-design/forms";
import ParvandehRoleHistory from "./ParvandehRoleHistory.vue";
import ParvandehRoleSelect from "./ParvandehRoleSelect.vue";
import { computed, ref, toRefs } from "vue";
import { generateError, generateLang, toastAlert } from "@/shared/utils";
import { editParvandehRole } from "@/modules/profile/services";

export default {
  components: {
    LeftSidebar,
    Button,
    ParvandehRoleHistory,
    ParvandehRoleSelect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    parvandehData: {
      type: Object,
      default: null,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { visible, title, parvandehData } = toRefs(props);

    // generate show history page
    const toggleHistory = ref(false);
    const showHistory = () => (toggleHistory.value = true);
    const backToRoles = () => (toggleHistory.value = false);

    // generate sidebar title
    const generateTitle = computed(() =>
      toggleHistory.value
        ? `${generateLang(["history_of_select_roles_for"])} ${
            parvandehData.value.fullName
          }`
        : title.value
    );

    // update selected roles
    const selectedRoles = ref([]);
    const handleSelectedRoles = (items) => {
      selectedRoles.value = [...items];
    };

    // submit roles
    const loading = ref(false);
    const submit = async () => {
      try {
        loading.value = true;
        const { code } = parvandehData.value;
        const roleCodes = selectedRoles.value.map((item) => item.code);
        const response = await editParvandehRole(code, roleCodes);
        const { message } = response;
        toastAlert(message);
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };

    const close = () => emit("close");

    return {
      visible,
      title,
      parvandehData,
      toggleHistory,
      generateTitle,
      loading,
      close,
      showHistory,
      backToRoles,
      handleSelectedRoles,
      submit,
    };
  },
};
</script>
